import { Application, ApplicationType } from '@phn/utility/constants/app';
import { NavigationMode, NavigationModeType, NavigationTheme, NavigationThemeType } from '@phn/utility/constants';

export function sanitizeMode(mode: NavigationModeType): NavigationModeType {
  if (!Object.keys(NavigationMode).includes(mode)) {
    return NavigationMode.navbar;
  }
  return mode;
}

export function sanitizeTheme(theme: NavigationThemeType): NavigationThemeType {
  if (!Object.keys(NavigationTheme).includes(theme)) {
    return NavigationTheme.light;
  }
  return theme;
}

export function sanitizeApp(app: string): ApplicationType {
  if (!Object.keys(Application).includes(app)) {
    return Application.default;
  }
  return app as ApplicationType;
}

export function constructThemeClass(mode: NavigationModeType, theme: NavigationThemeType): string {
  const sanitizedMode = sanitizeMode(mode);
  if (sanitizedMode === NavigationMode.navbar) {
    return NavigationMode.navbar;
  }

  const sanitizedTheme = sanitizeTheme(theme);
  return `${mode}_${sanitizedTheme}`;
}

export function isPromise<T>(value: unknown): value is Promise<T> {
  return (
    Boolean(value) &&
    typeof (value as Promise<T>).then === 'function' &&
    (value as Promise<T>)[Symbol.toStringTag] === 'Promise'
  );
}
